import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgNavAgents = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="M3 3h4.5v4.5H3V3ZM16.5 3H21v4.5h-4.5v9h-9v-9h9V3ZM21 16.5h-4.5V21H21v-4.5ZM3 16.5h4.5V21H3v-4.5Z"
    />
  </svg>
);
export default SvgNavAgents;
